<div class="wrapper">
    <div class="header">
        <div>{{!label.id ? 'Add' : 'Edit'}} Label</div>
        <svg-icon (click)="close$.next()"
            [svgStyle]="{ 'width.px':18 , fill: '#6c757d', cursor: 'pointer'}"
            src="assets/images/icon-menu-close.svg"></svg-icon>
    </div>
    <div class="add-label-input">
        <input type="text"
            placeholder="Label name"
            [formControl]="labelTextControl">
    </div>
    <div class="color-select">
        <div class="color-item"
            (click)="selectLabelColour(i)"
            *ngFor="let color of colours;let i = index"
            [style.backgroundColor]="color">
            <svg-icon *ngIf="selectedColour === i"
                [svgStyle]="{ 'width.px':18 , fill: '#fff'}"
                src="assets/images/Check.svg"></svg-icon>
        </div>
    </div>
    <button (click)="onSubmit()"
        [disabled]="labelTextControl.invalid || (!selectedColour && selectedColour !== 0)"
        class="btn btn-primary btn-sm">{{!label.id ? 'Create' : 'Edit'}}</button>

</div>